import { db } from '../../firebase';
import firebase from 'firebase/app';

// import { getXrossUserProfileByList } from '$common/firebase/user';

// xross interface
// import { XROSS_BLOCKED_USER, XROSS_PUBLIC_USER_INFO } from '$common/interface';

// xross define
// import { _ACTIVE_ } from '$common/define';

// logger
// impoblockUserrt { debugLog, errorLog, infomationLog } from '$common/lib/logger';

// コレクション名定義
import { CL_USER, SCL_BLOCKS, SCL_BLOCKEDBY } from '../define';

// /*
//  * -----------------------------------------------------------------
//  * 自分がブロックしたユーザリストを取得する（返却値：uid）
//  * -----------------------------------------------------------------
//  */
// export const getBlocksUidList = async (
//   uid: string
// ): Promise<XROSS_BLOCKED_USER[]> => {
//   try {
//     const snapshot = await db
//       .collection(CL_USER)
//       .doc(uid)
//       .collection(SCL_BLOCKS)
//       .orderBy('createdAt', 'desc')
//       .get();

//     const users = snapshot.docs.map(
//       (doc) => ({ ...doc.data(), id: doc.id } as XROSS_BLOCKED_USER)
//     );

//     return users;
//   } catch (err) {
//     errorLog('getBlocksUidList>> ', err);
//     return [];
//   }
// };

// //
// // 自分をブロックしたユーザリストを取得する（依頼）（返却値：uid）
// //
// export const getBlockedByUserList = async (uid: string) => {
//   try {
//     const snapshot = await db
//       .collection(CL_USER)
//       .doc(uid)
//       .collection(SCL_BLOCKEDBY)
//       .get();
//     const users = snapshot.docs.map(
//       (doc) => ({ ...doc.data(), id: doc.id } as XROSS_BLOCKED_USER)
//     );

//     return users;
//   } catch (err) {
//     errorLog('getBlockedByUserList>> ', err);
//     return [];
//   }
// };

// //
// // 自分がブロックしたユーザリストを取得する（返却値：ユーザ情報）
// //
// export const getBlockedUserInfoList = async (uid: string) => {
//   const userInfo: XROSS_PUBLIC_USER_INFO[] = [];
//   try {
//     const snapshot = await db
//       .collection(CL_USER)
//       .doc(uid)
//       .collection(SCL_BLOCKS)
//       .get();
//     const users = snapshot.docs.map(
//       (doc) => ({ ...doc.data(), id: doc.id } as XROSS_BLOCKED_USER)
//     );

//     const uidList = [];
//     for (let i = 0; i < users.length; i++) {
//       uidList.push(users[i].uid);
//     }
//     const userList = await getXrossUserProfileByList(uidList);
//     for (let i = 0; i < userList.length; i++) {
//       // BAN & 退会ユーザは除く 2022-08-01
//       if (userList[i]?.xrossUserStatus === _ACTIVE_) {
//         userInfo.push(userList[i]);
//       }
//     }
//     return userInfo;
//   } catch (err) {
//     errorLog('getBlockedUserInfoList>> ', err);
//     return [];
//   }
// };

// //
// // 自分をブロックしたユーザリストを取得する（返却値：ユーザ情報）
// //
// export const getBlockedByUserInfoList = async (uid: string) => {
//   const userInfo: XROSS_PUBLIC_USER_INFO[] = [];
//   try {
//     const snapshot = await db
//       .collection(CL_USER)
//       .doc(uid)
//       .collection(SCL_BLOCKEDBY)
//       .get();
//     const users = snapshot.docs.map(
//       (doc) => ({ ...doc.data(), id: doc.id } as XROSS_BLOCKED_USER)
//     );

//     const uidList = [];
//     for (let i = 0; i < users.length; i++) {
//       uidList.push(users[i].uid);
//     }
//     const userList = await getXrossUserProfileByList(uidList);
//     for (let i = 0; i < userList.length; i++) {
//       // BAN & 退会ユーザは除く 2022-08-01
//       if (userList[i]?.xrossUserStatus === _ACTIVE_) {
//         userInfo.push(userList[i]);
//       }
//     }

//     return userInfo;
//   } catch (err) {
//     errorLog('getBlockedByUserInfoList>> ', err);
//     return [];
//   }
// };

//
// ブロックする
//
export const blockUser = async (fromUid: string, targetUid: string) => {
  console.log(
    'blockUser>> called fromUid = ' + fromUid,
    ' targetUid = ',
    targetUid
  );
  await db
    .collection(CL_USER)
    .doc(fromUid)
    .collection(SCL_BLOCKS)
    .doc(targetUid)
    .set({
      uid: targetUid,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });

  // （相手）友達申請を受けたユーザのコレクション更新
  await db
    .collection(CL_USER)
    .doc(targetUid)
    .collection(SCL_BLOCKEDBY)
    .doc(fromUid)
    .set({
      uid: fromUid,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
};

//
// ブロックを解除する
//
export const unblockUser = async (fromUid: string, target: string) => {
  // console.log('unblockUser>> called uid = ' + uid, ' target = ', target);

  // ブロックを解除する
  await db
    .collection(CL_USER)
    .doc(fromUid)
    .collection(SCL_BLOCKS)
    .doc(target)
    .delete()
    .then(() => {
      console.log('Document successfully deleted!');
    })
    .catch((error) => {
      console.log('Error removing document: ', error);
    });

  // （相手）ブロックを解除されたユーザのコレクション更新
  await db
    .collection(CL_USER)
    .doc(target)
    .collection(SCL_BLOCKEDBY)
    .doc(fromUid)
    .delete()
    .then(() => {
      console.log('Document successfully deleted!');
    })
    .catch((error) => {
      console.log('Error removing document: ', error);
    });
};
